<template>
  <div>
    <el-dialog
      @close="close"
      title="新增"
      :visible.sync="openCardDialog"
      width="30%">
      <el-form label-width="60px" :model="fromData">
        <el-form-item label="图标">
          <el-upload
            :limit="1"
            action=""
            list-type="picture-card"
            :on-change="imgBroadcastChange"
            :show-file-list="false"
            :auto-upload="false">
            <el-image style="width: 100%;height: 100%" v-if="fromData.imageUrl" :src="fromData.imageUrl" class="avatar"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item label="名称">
          <el-input size="small" v-model="fromData.content"></el-input>
        </el-form-item>
        <el-form-item label="url">
          <el-input size="small" v-model="fromData.url"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" size="small" v-model="fromData.describe"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="determine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "organizational",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      fileList:'',
      fromData: {}
    };
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods:{
    close() {
      this.fromData = {}
    },
    // 取消
    cancel() {
      this.$emit('cancelOrganizational',this.fromData)
    },
    // 确定
    determine() {
      this.$emit('determineOrganizational',this.fromData)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    imgBroadcastChange(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (isLt2M) {
        // uploadImgToBase64()返回一个Promise对象，通过.then()获取其数据。其中data.result是图片转成的base64值
        this.uploadImgToBase64(file.raw).then(data => { this.fromData.imageUrl = data.result })
      } else {
        this.$message.error('上传封面图片大小不能超过 2MB!')
      }
    },
    uploadImgToBase64(file) {  //核心方法，将图片转成base64字符串形式
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function() { // 图片转base64完成后返回reader对象
          resolve(reader)
        }
        reader.onerror = reject
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pageConfig/organizational.vue